import {ShipperCustomerTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class ShipperCustomerTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in ShipperCustomerTypeCd ) {
      this._values.push(ShipperCustomerTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): ShipperCustomerTypeCd {

    for ( const obj in ShipperCustomerTypeCd ) {
      if (ShipperCustomerTypeCd[obj] === value){
        return ShipperCustomerTypeCd[obj] as ShipperCustomerTypeCd;
      }
    }
  }
}

const ShipperCustomerTypeCdHelper = new ShipperCustomerTypeCdHelperEnumHelperClass();
export default ShipperCustomerTypeCdHelper;
